import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
import routes from './path'




const router = new Router({
  //mode: 'history',
  routes
})



router.beforeEach((to, from, next) => {
  if(to.path == "/userlogin") {
    let pathGoing = window.sessionStorage.getItem('goingto');
    if(pathGoing) {
      window.sessionStorage.setItem("goingto",'');
      store.state.UserLogin.loginSucceed = true
      next({
        path:pathGoing
      })
    } else {
      next()
    }
  }else if(to.path == "/pay" || to.path == "/oauthapply" || to.path == "/useragreement"){
    next()
  } else if(to.path == "/personaldetails"){
    next()
  } else if(to.path == "/wxspacedetails" || to.path == "/wxsweep"){
    next()
  }else if(to.path == "/updaterecord"){
    next()
  }else {
    let loginInfo = window.sessionStorage.getItem("binyi_cms_loginInfo");
    
    if(loginInfo) {
      store.state.UserLogin.loginSucceed = true
      next()
    } else {
      next({
        path: "/userlogin",
        replace: true
      });
    }
  }

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js